<template>
	<div class="fees gray-bar-top app clearfix">
		<h3 class="app-title">Fees</h3>
		<div class="row">
			<div class="col-md-12">
				<div class="data-row gray-bar-bottom clearfix">
					<span>Annual Management Fees</span>
					<span class="data">{{ $format.rawPercent(ManagementFee) }}</span>
				</div>
				<div
					v-if="isAuthorizedModule['acquiredFees']"
					id="_acquiredFees"
					class="data-row gray-bar-bottom clearfix"
				>
					<span>Acquired (underlying) fund fees and expenses</span>
					<span class="data">{{ $format.rawPercent(UnderlyingFundsFee) }}</span>
				</div>
				<div class="data-row gray-bar-bottom clearfix">
					<span>Other Expenses</span>
					<span class="data">{{ $format.rawPercent(OtherFees) }}</span>
				</div>
				<div class="data-row gray-bar-bottom clearfix">
					<span>Service 12b-1</span>
					<span class="data">{{ $format.rawPercent(Service12b1Fee) }}</span>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<br>
				<span class="com-mod-level-2-disclosure">As of each fund's most recent prospectus.</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	name: 'Fees',
	components: {},
	computed: {
		...mapGetters([
			'ManagementFee',
			'OtherFees',
			'Service12b1Fee',
			'UnderlyingFundsFee'
		])
	},
	watch: {
		ManagementFee: {
			immediate: true,
			handler(val) {
				this.updateExcelData(val, null, null, null);
			}
		},
		OtherFees: {
			immediate: true,
			handler(val) {
				this.updateExcelData(null, val, null, null);
			}
		},
		Service12b1Fee: {
			immediate: true,
			handler(val) {
				this.updateExcelData(null, null, val, null);
			}
		},
		UnderlyingFundsFee: {
			immediate: true,
			handler(val) {
				this.updateExcelData(null, null, null, val);
			}
		}
	},
	methods: {
		updateExcelData(
			managementFee,
			OtherFees,
			Service12b1Fee,
			underlyingFundsFee
		) {
			if (!managementFee) {
				managementFee = this.ManagementFee;
			}
			if (!OtherFees) {
				OtherFees = this.OtherFees;
			}
			if (!Service12b1Fee) {
				Service12b1Fee = this.Service12b1Fee;
			}
			if (!underlyingFundsFee) {
				underlyingFundsFee = this.UnderlyingFundsFee;
			}
			this.$EventBus.$emit('ExcelData', 'FeesModule', {
				managementFee,
				OtherFees,
				Service12b1Fee,
				underlyingFundsFee
			});
		}
	}
};
</script>

<style lang="less" scoped>
.app {
	font-family: 'AvenirNextLTW01-Regular';
	font-size: 14px;
	.data {
		color: #333;
		float: right;
	}
	table {
		border-collapse: collapse;
	}
	.data-row {
		color: #666;
		padding: 5px 0px;
	}
	.adjust-date {
		margin-top: 5px;
	}
}
.com-mod-level-2-disclosure {
	font-size: 12px;
	font-family: 'AvenirNextLTW01-Condens 721299', Arial;
	color: #666;
}
</style>
